// DropDownBabyChairs.jsx
import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";

import { ConfirmationModal } from "../ConfirmationModal"; // ⬅️ your modal

/* ——— styles (same look) ——— */
const BtnLeft = styled.div`
  padding: 2px;
  display: flex;
  height: 100%;
  width: 70%;
  align-items: center;
  justify-content: center;
  border-right: 1px solid gray;
  cursor: pointer;
  color: #99b0ad;
  font-size: 12px;
  font-weight: bold;
  background-color: white;
  border-radius: 5px 0 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const BtnRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
  cursor: pointer;
  background-color: white;
  border-radius: 0 5px 5px 0;
`;

/* ——— component ——— */
function DropDownBabyChairs({
  babyChairFree = [], // free list from API
  existingBabyChairs = 0, // total chairs in restaurant
  fromRestaurant = false, // flag to mark overflow as occupied
  initial = 0, // starting value
  onChange, // (n) => void
}) {
  /* 1 ▸ build option list & occupied set */
  const explicit = Array.isArray(babyChairFree) ? babyChairFree : [];
  const autoRange =
    fromRestaurant && existingBabyChairs > explicit.length
      ? Array.from(
          { length: existingBabyChairs - explicit.length },
          (_, i) => explicit.length + i + 1
        )
      : [];
  const options = [0, ...explicit, ...autoRange];
  const occupiedSet = new Set(autoRange);

  /* 2 ▸ UI state */
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(initial);
  const [pending, setPending] = useState(null); // chair awaiting confirm
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
  const [openUpward, setOpenUpward] = useState(false);

  const btnRef = useRef(null);
  const selectedRef = useRef(null);
  const dropdownRef = useRef(null);

  /* keep external initial in sync */
  useEffect(() => {
    setSelected(initial);
    console.log("initial: ", initial);
  }, [initial]);

  /* scroll selected into view */
  useEffect(() => {
    if (isOpen && selectedRef.current) {
      selectedRef.current.scrollIntoView({ block: "center" });
    }
  }, [isOpen]);

  /* compute pop-up position */
  useEffect(() => {
    if (isOpen && btnRef.current && dropdownRef.current) {
      const r = btnRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - r.bottom;
      const spaceAbove = r.top;

      const shouldOpenUp =
        spaceBelow < dropdownHeight && spaceAbove > dropdownHeight;

      setOpenUpward(shouldOpenUp);
      setPos({
        top: shouldOpenUp
          ? r.top + window.scrollY - dropdownHeight
          : r.bottom + window.scrollY,
        left: r.left + window.scrollX,
        width: r.width,
      });
    }
  }, [isOpen]);

  /* 3 ▸ click handler */
  const handleClick = (n, e) => {
    e.preventDefault();

    if (occupiedSet.has(n)) {
      // show confirmation modal; remember which value was clicked
      setPending(n);
      return;
    }

    // free chair → accept immediately
    setSelected(n);
    onChange && onChange(n);
    setIsOpen(false);
  };

  /* 4 ▸ helpers */
  const label = (n) => (occupiedSet.has(n) ? `${n} (ocupada)` : String(n));
  const lineStyle = (n) => (occupiedSet.has(n) ? { color: "#D94B4B" } : null);

  /* 5 ▸ render */
  return (
    <>
      {/* main button */}
      <div
        className="form-control-people"
        ref={btnRef}
        onClick={() => setIsOpen((p) => !p)}
      >
        <BtnLeft>
          {selected === 0
            ? "Cadeiras"
            : occupiedSet.has(selected)
            ? `${selected} (ocupada)`
            : selected}
        </BtnLeft>
        <BtnRight>
          <FontAwesomeIcon
            icon={faChevronCircleDown}
            size="xl"
            color="#EE754C"
            className={isOpen ? "rotate-menu-arrow" : ""}
          />
        </BtnRight>
      </div>

      {/* dropdown list */}
      {isOpen &&
        ReactDOM.createPortal(
          <div
            ref={dropdownRef}
            className="custom-dropdown-menu"
            style={{
              position: "absolute",
              top: pos.top,
              left: pos.left,
              width: pos.width,
              zIndex: 9999,
            }}
          >
            {options.map((n) => (
              <div
                key={n}
                className={`dropdown-menu-item ${
                  n === selected ? "selected" : ""
                }`}
                style={lineStyle(n)}
                onClick={(e) => handleClick(n, e)}
                ref={n === selected ? selectedRef : null}
              >
                {label(n)}
              </div>
            ))}
          </div>,
          document.body
        )}

      {/* confirmation modal */}
      <ConfirmationModal
        show={pending !== null}
        onHide={() => setPending(null)}
        onCancel={() => setPending(null)}
        onConfirm={() => {
          // user accepted -> commit the pending value
          setSelected(pending);
          onChange && onChange(pending);
          setPending(null);
          setIsOpen(false);
        }}
        title="Cadeira ocupada"
        body={
          pending !== null &&
          `A quantidade de cadeiras selecionada não está disponível. Continuar mesmo assim?`
        }
        confirmLabel="Continuar"
        cancelLabel="Cancelar"
        confirmColor="#EE754C"
        cancelColor="#6c757d"
      />
    </>
  );
}

export default DropDownBabyChairs;
